module.exports = __webpack_public_path__ + "static/img/logo.b5430b10.svg";